import script from "./aboutUs.vue?vue&type=script&setup=true&lang=js"
export * from "./aboutUs.vue?vue&type=script&setup=true&lang=js"

import "./aboutUs.vue?vue&type=style&index=0&id=459f5d0f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-459f5d0f"]])

export default __exports__